import { PrintConfiguration } from './contracts';
import currentConfig from '../../../utils/AppConfig';

interface PdfUrlResult {
  url?: string;
  error?: string;
}

const usePdfUrl = async (
  payload: PrintConfiguration,
  token?: string | undefined | null,
): Promise<PdfUrlResult> => {
  const result: PdfUrlResult = {};
  const exportFormat = payload.MapOnly === true ? 'png' : 'pdf';
  try {
    const response = await fetch(currentConfig.apis.print, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    result.url = await response.text();
  } catch (error) {
    result.error = `Error fetching ${exportFormat} URL: ${error}`;
  }

  return result;
};

export default usePdfUrl;
